import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["rendersBody", "totalRenders", "avgDuration", "totalCost", "tzToggle"]
  static classes = ["localTz"]

  connect() {
    this.showLocal = false
    this.subscription = consumer.subscriptions.create(
      { channel: "TelemetryDashboardChannel" },
      { received: (data) => this.handleUpdate(data) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleUpdate(data) {
    if (data.action === "upsert_render") {
      this.upsertRenderRow(data)
    }

    if (data.stats) {
      this.updateStats(data.stats)
    }
  }

  upsertRenderRow(data) {
    if (!this.hasRendersBodyTarget || !data.row_html) return

    const existing = document.getElementById(`telemetry-render-${data.render_id}`)
    if (existing) {
      existing.outerHTML = data.row_html
    } else {
      this.rendersBodyTarget.insertAdjacentHTML("afterbegin", data.row_html)
    }
  }

  toggleTimezone() {
    this.showLocal = !this.showLocal
    this.element.classList.toggle("telemetry--local-tz", this.showLocal)
    if (this.hasTzToggleTarget) {
      const svg = this.tzToggleTarget.querySelector("svg")
      this.tzToggleTarget.textContent = this.showLocal ? "+08 " : "UTC "
      if (svg) this.tzToggleTarget.appendChild(svg)
    }
  }

  updateStats(stats) {
    if (this.hasTotalRendersTarget && stats.total_renders != null) {
      this.totalRendersTarget.textContent = stats.total_renders
    }
    if (this.hasAvgDurationTarget && stats.avg_duration != null) {
      this.avgDurationTarget.textContent = stats.avg_duration
    }
    if (this.hasTotalCostTarget && stats.total_cost != null) {
      this.totalCostTarget.textContent = stats.total_cost
    }
  }
}
